module.exports = {
	"name": "@botpress/channel-web",
	"version": "10.51.9",
	"description": "An embeddable web chat for Botpress bots",
	"main": "bin/node.bundle.js",
	"homepage": "https://github.com/botpress/modules",
	"botpress": {
		"menuText": "Web Chat",
		"menuIcon": "chrome_reader_mode",
		"webBundle": "bin/web.bundle.js",
		"noInterface": true,
		"plugins": [
			{
				"entry": "WebBotpressUIInjection",
				"position": "overlay"
			}
		]
	},
	"publishConfig": {
		"access": "public"
	},
	"scripts": {
		"test": "echo \"Error: no test specified\" && exit 1",
		"watch": "node webpack.js --watch",
		"compile": "node webpack.js --compile"
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/botpress/modules"
	},
	"author": "Botpress",
	"license": "AGPL-3.0-only",
	"peerDependencies": {
		"botpress": ">= 10.0.0"
	},
	"devDependencies": {
		"babel-core": "^6.26.0",
		"babel-loader": "^7.1.2",
		"babel-plugin-transform-async-to-generator": "^6.22.0",
		"babel-plugin-transform-decorators-legacy": "^1.3.4",
		"babel-plugin-transform-object-rest-spread": "^6.16.0",
		"babel-preset-latest": "^6.16.0",
		"babel-preset-react": "^6.24.0",
		"babel-preset-stage-0": "^6.16.0",
		"babel-register": "^6.18.0",
		"classnames": "^2.2.5",
		"copy-webpack-plugin": "^4.3.1",
		"core-js": "^2.4.1",
		"css-loader": "^0.28.8",
		"extract-text-webpack-plugin": "^3.0.2",
		"file-loader": "^1.1.6",
		"image-webpack-loader": "^3.4.2",
		"node-sass": "^4.9.3",
		"raw-loader": "^0.5.1",
		"react-chatview": "^0.2.5",
		"react-dropzone": "^3.13.1",
		"react-linkify": "^0.2.2",
		"react-resizable-box": "^2.0.4",
		"react-slick": "^0.23.2",
		"react-spinkit": "^3.0.0",
		"sass-loader": "^6.0.6",
		"slick-carousel": "^1.8.1",
		"snarkdown": "^1.2.2",
		"style-loader": "^0.19.1",
		"webpack": "^3.10.0",
		"webpack-node-externals": "^1.6.0"
	},
	"dependencies": {
		"aws-sdk": "^2.108.0",
		"axios": "^0.16.2",
		"bluebird": "^3.5.1",
		"date-fns": "^1.28.5",
		"lodash": "^4.17.4",
		"lru-cache": "^4.1.3",
		"mime": "^2.0.3",
		"moment": "^2.18.1",
		"ms": "^2.1.1",
		"multer": "^1.3.0",
		"multer-s3": "^2.7.0",
		"query-string": "^5.0.1",
		"react-ga": "^2.4.1",
		"serve-static": "^1.12.3",
		"sillyname": "^0.1.0",
		"uuid": "^3.1.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 24
// module chunks = 0